import type { Writing } from "./types";

const writing: Writing = {
  slug: "design-stack-2026",
  title: "My design stack of 2026",
  date: "2026",
  status: "WIP",
  description: "Coming soon",
  placeholder: [],
};

export default writing;
